import { useEffect, useState } from "react";

// component
import {
  InputText,
  InputTextTel,
  InputTextName,
  InputTextZipCode,
  InputTextSpace,
  InputTextMailAddress,
  InputTextFormTel,
  InputMultiText,
} from "../component/input";
import { CancellSubmitBottom } from "../component/submitBotton";

// config
import { options } from "../config/cancellOptions";

// jotai
import { useAtomValue } from "jotai";
import { AppAtoms } from "../lib/store";

function CancellForm() {
  // 事前取得情報
  const layoutConfig = useAtomValue(AppAtoms.layoutConfig);

  // form 入力データ
  const formDataColumns = options.reduce((column, difine) => {
    if (difine.option_name == "生年月日") {
      return {
        ...column,
        [difine.option_name]: "2000-01-01",
      };
    } else {
      return {
        ...column,
        [difine.option_name]: "",
      };
    }
  }, {});
  const [formData, setFormData] = useState<{
    [key: string]: string | string[];
  }>(formDataColumns);

  // 申込ボタンを押せるかどうか trueで押せない
  const [disableFormBottom, setDisableFormBottom] = useState(true);
  useEffect(() => {
    let disableFormBottom = false;
    options.map((option) => {
      if (
        option.required_optional === 1 &&
        (formData[option.option_name] == "" ||
          formData[option.option_name] == " " ||
          formData[option.option_name] == "--")
      ) {
        disableFormBottom = true;
      }
    });
    setDisableFormBottom(disableFormBottom);
  }, [formData]);
  return (
    <div className="contact_wrap">
      <h2 id="outline__1">ご解約</h2>
      <div
        className="wpcf7 js"
        id="wpcf7-f6-o1"
        lang="ja"
        dir="ltr"
        data-wpcf7-id="6"
      >
        <div className="wpcf7-form init">
          {options.map((option) => {
            if (option.tel_flg === 1) {
              return (
                <InputTextTel
                  option={option}
                  formData={formData}
                  setFormData={setFormData}
                  setFormTel={() => {}}
                  setFormEMail={() => {}}
                  addressOptionName={""}
                />
              );
            } else if (option.name_flg === 1) {
              return (
                <InputTextName
                  option={option}
                  formData={formData}
                  setFormData={setFormData}
                  setFormTel={() => {}}
                  setFormEMail={() => {}}
                  addressOptionName={""}
                />
              );
            } else if (option.zip_code_flg === 1) {
              return (
                <InputTextZipCode
                  option={option}
                  formData={formData}
                  setFormData={setFormData}
                  setFormTel={() => {}}
                  setFormEMail={() => {}}
                  addressOptionName={""}
                />
              );
            } else if (option.space_flg === 1) {
              return (
                <InputTextSpace
                  option={option}
                  formData={formData}
                  setFormData={setFormData}
                  setFormTel={() => {}}
                  setFormEMail={() => {}}
                  addressOptionName={""}
                />
              );
            } else if (option.mail_address_flg === 1) {
              return (
                <InputTextMailAddress
                  option={option}
                  formData={formData}
                  setFormData={setFormData}
                  setFormTel={() => {}}
                  setFormEMail={() => {}}
                  addressOptionName={""}
                />
              );
            } else if (option.form_tel_flg === 1) {
              return (
                <InputTextFormTel
                  option={option}
                  formData={formData}
                  setFormData={setFormData}
                  setFormTel={() => {}}
                  setFormEMail={() => {}}
                  addressOptionName={""}
                />
              );
            } else if (option.multi_text_flg === 1) {
              return (
                <InputMultiText
                  option={option}
                  formData={formData}
                  setFormData={setFormData}
                  setFormTel={() => {}}
                  setFormEMail={() => {}}
                  addressOptionName={""}
                />
              );
            } else {
              return (
                <InputText
                  option={option}
                  formData={formData}
                  setFormData={setFormData}
                  setFormTel={() => {}}
                  setFormEMail={() => {}}
                  addressOptionName={""}
                />
              );
            }
          })}
          <CancellSubmitBottom
            submit_text={"送信する"}
            formData={formData}
            disabled={disableFormBottom}
          />
        </div>
        {layoutConfig.outside_cancell_form_text !== "" ? (
          <p className="switch_title">
            {layoutConfig.outside_cancell_form_text}
          </p>
        ) : null}
      </div>
    </div>
  );
}
export default CancellForm;
